import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  loadAutomationRulesError: {
    id: 'JVX1fG',
    defaultMessage: 'Failed to load automation rules. Please refresh the page.',
    description: 'Error message shown when automation rules fail to load',
  },
  noRuleFoundError: {
    description: 'Error banner message when no rate shopper automation rule is found',
    defaultMessage: 'No Rate Shopper automation rule found.',
    id: 'S37Hh+',
  },
  noRuleFoundErrorWithLink: {
    description: 'Error banner message when no rate shopper automation rule is found, with a link to the automation rules settings page',
    defaultMessage: 'No Rate Shopper automation rule found. <a>Go to Automation Rules</a>',
    id: 'FJp5dX',
  },
  updateFailedError: {
    id: 'JHB5vD',
    defaultMessage: 'Failed to update rate shopper preference. Please try again.',
    description: 'Error message when rate shopper update fails',
  },
  updateSuccessTitle: {
    id: 'Ly9zNL',
    defaultMessage: 'Rate Shopper Updated',
    description: 'Title for successful rate shopper update notification',
  },
  updateSuccessContent: {
    id: 'gS67f+',
    defaultMessage: 'Your default rate shopper preference has been updated.',
    description: 'Content for successful rate shopper update notification',
  },
  updateFailedTitle: {
    id: 'hPDtVd',
    defaultMessage: 'Update Failed',
    description: 'Title for failed rate shopper update notification',
  },
});
